import { render, staticRenderFns } from "./TariffEditModal.vue?vue&type=template&id=de2e5a2e&scoped=true&"
import script from "./TariffEditModal.vue?vue&type=script&lang=js&"
export * from "./TariffEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2e5a2e",
  null
  
)

export default component.exports